<template>

  <div class="d-flex">
    <div class="btn-group mr-1">
      <button 
        type="button" 
        class="btn" 
        :class="{'btn-secondary': status === 'qualified', 'btn-light': status !== 'qualified'}" 
        @click="setStatus('qualified')">
        <i class="fas fa-thumbs-up hide-bigger-sm" />
        <span class="hide-less-sm">{{ $t('Qualifieds') }}</span>
        ({{ job.pipeline.qualified }})
        </button>
      <button
        type="button" 
        class="btn" 
        :class="{'btn-secondary': status === 'disqualified', 'btn-light': status !== 'disqualified'}" 
        @click="setStatus('disqualified')">
        <i class="fas fa-ban hide-bigger-sm" />
        <span class="hide-less-sm">{{ $t('Disqualifieds') }}</span>
        ({{ job.pipeline.disqualified }})
        </button>
    </div>
    <div>
      <input-keyword 
        class="input-keyword"
        @input="setKeywords" 
        :placeholder="$t('Search')" />
    </div>
  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'

export default {
  name: 'JobBoardFilters',
  components: {
    InputKeyword
  },
  data () {
    return {
      keywords: false,
      status: 'qualified'
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    /*
    setKeywords
    */
    setKeywords (keyword) {
      this.keywords = keyword
      this.setFilters()
    },
    /*
    setStatus
    */
    setStatus (status) {
      this.status = status
      this.setFilters()
    },
    /*
    setStatus
    */
    setFilters () {
      const filters = {
        'status': this.status,
        ...(this.keywords ? {identity: '~' + this.keywords} : {})
      }

      this.$emit('setFilters', filters)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width : 576px) {
  .input-keyword {
    min-width: 180px;
  }
}
@media (max-width : 576px) {
  .input-keyword {
    max-width: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Job/JobBoard/JobBoardFilters.vue